import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { ReactComponent as MarkerFormatCircle } from 'common/Prose/Toolbar/components/Format/components/ToggleListPane/BulletListButton/markerFormatCircle.svg'
import { ReactComponent as MarkerFormatDiamond } from 'common/Prose/Toolbar/components/Format/components/ToggleListPane/BulletListButton/markerFormatDiamond.svg'
import { ReactComponent as MarkerFormatSquare } from 'common/Prose/Toolbar/components/Format/components/ToggleListPane/BulletListButton/markerFormatSquare.svg'
import { useBulletListMarkerToggle } from 'common/Prose/Toolbar/hooks/useBulletListMarkerToggle'
import { useBulletListToggle } from 'common/Prose/Toolbar/hooks/useBulletListToggle'
import { observer } from 'mobx-react-lite'
import { MARKER_FORMAT } from 'prose-core'
import { SoftButton } from '../Buttons/Button'
import { SimpleDropdown } from '../SimpleDropdown/SimpleDropdown'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

const BulletListCircle = observer(function BulletListCircle() {
  const { active, handleClick } = useBulletListMarkerToggle(MARKER_FORMAT.CIRCLE)

  return (
    <SoftButton onClick={handleClick} active={active} aria-label="Toggle circle bullet list">
      <MarkerFormatCircle />
    </SoftButton>
  )
})

const BulletListDiamond = observer(function BulletListDiamond() {
  const { active, handleClick } = useBulletListMarkerToggle(MARKER_FORMAT.DIAMOND)

  return (
    <SoftButton onClick={handleClick} active={active} aria-label="Toggle diamond bullet list">
      <MarkerFormatDiamond />
    </SoftButton>
  )
})

const BulletListSquare = observer(function BulletListSquare() {
  const { active, handleClick } = useBulletListMarkerToggle(MARKER_FORMAT.SQUARE)

  return (
    <SoftButton onClick={handleClick} active={active} aria-label="Toggle square bullet list">
      <MarkerFormatSquare />
    </SoftButton>
  )
})

export const BulletedListButtons = () => (
  <>
    <BulletListCircle />
    <BulletListDiamond />
    <BulletListSquare />
  </>
)

export const BulletListDropdown = observer(function BulletListDropdown() {
  const view = useEditorView()
  const { active, handleClick } = useBulletListToggle(view)

  return (
    <SimpleDropdown
      horizontal
      active={active}
      hasChevron={false}
      clickAction={handleClick}
      tooltip={{ label: 'Bulleted list' }}
      label="Toggle bulleted list"
      placement="bottom"
    >
      <ToolbarIcon name={IconName.List} />
      <BulletedListButtons />
    </SimpleDropdown>
  )
})
